import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';


function App() {
  return (
    <div className="App">
        <BrowserRouter>
        <script src="https://kit.fontawesome.com/08cd054ba5.js" crossOrigin="anonymous"></script>
        <Routes>
              <Route path="/" element={<LoginPage/>} />
              <Route path="/login" element={<LoginPage/>} />
              <Route path="/login/:error" element={<LoginPage/>} />
              <Route path="/request/:loading/:code" element={<LoginPage />} />
              <Route path="/forms/:form" element={<LoginPage/>} />

        </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
